import { ComponentPropsWithoutRef } from 'react';

import styles from './Count.module.scss';

type Props = {
	count: number | string;
} & ComponentPropsWithoutRef<'span'>;

export function Count({ count, className = '', ...rest }: Props) {
	return (
		<span className={`body7 ${styles.count} ${className}`} {...rest}>
			{count}
		</span>
	);
}
